import { CRUDEntity } from "../abstracts/CRUDEntity";

export class InvoiceCategory extends CRUDEntity {

    constructor(id=null) {
        super();
        this.entityClass = 'category';
        this.urlRoot = '/price-book/category';
        this.sectionRootUrl = '/price-book';
        this.id = id;
    }
}